import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SolutionsHeroNew } from "@/components/solutions/SolutionsHeroNew";
import { SolutionsBentoGrid } from "@/components/solutions/SolutionsBentoGrid";
import { SolutionsShowcase } from "@/components/solutions/SolutionsShowcase";
import { V2GCaseStudy } from "@/components/solutions/V2GCaseStudy";
import { DERMSIntegration } from "@/components/solutions/DERMSIntegration";
import { SolutionsCTANew } from "@/components/solutions/SolutionsCTANew";
import { SEO, solutionsPageSchema } from "@/components/SEO";

const Solutions = () => {
  return (
    <main className="min-h-screen bg-background">
      <SEO
        title="EV Charging Solutions - V2G, DERMS & Smart Grid Integration"
        description="Complete EV charging solutions: V2G technology with 900MW discharged, DERMS integration, Fleet Charging, and Smart Charging. NEVI compliant."
        keywords="EV charging solutions, V2G, DERMS, utility integration, fleet charging, smart charging, OpenADR"
        canonicalUrl="/solutions"
        structuredData={solutionsPageSchema}
      />
      <Navbar />
      <SolutionsHeroNew />
      <SolutionsBentoGrid />
      <V2GCaseStudy />
      <DERMSIntegration />
      <SolutionsShowcase />
      <SolutionsCTANew />
      <Footer />
    </main>
  );
};

export default Solutions;
